import App from "../Core/App";

export default class BrowserHelper {

    // Detect IE version 11 and below as well as pre-full-webkit-support Edge.
    static isIE() {
        var edge_ident  = "Edge",
            ie_ident    = "MSIE ";

        var ua = window.navigator.userAgent || "";

        // IE 10 and below
        if( ua.indexOf(ie_ident) > 0 ) {
            return true;
        }

        // IE 11 (he's a little bit special...)
        if( (!!window.MSInputMethodContext && !!document.documentMode) || ua.indexOf("Trident") > 0 ) {
            return true;
        }

        if( ua.indexOf(edge_ident) > 0 ) {
            // We can allow version 16 and above
            var ver = ua.substr(ua.indexOf(edge_ident) + edge_ident.length + 1, 2);
            return parseInt(ver) <= 15;
        }

        // Not IE
        return false;
    }

    // Check if device is uses iOS
    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
    static isIOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    }
}
